"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2832],{

/***/ 69369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ BADGE_ENHANCER_SIZES; },
/* harmony export */   "AJ": function() { return /* binding */ dragShadowHeight; },
/* harmony export */   "E": function() { return /* binding */ FLOATING_MARKER_ANCHOR_POSITIONS; },
/* harmony export */   "Kp": function() { return /* binding */ EARNER_LOCATION_PUCK_CORE_SCALES; },
/* harmony export */   "P6": function() { return /* binding */ PINHEAD_TYPES; },
/* harmony export */   "T5": function() { return /* binding */ BADGE_ENHANCER_CONTENT_SIZE; },
/* harmony export */   "TO": function() { return /* binding */ KIND; },
/* harmony export */   "UZ": function() { return /* binding */ BADGE_ENHANCER_POSITIONS; },
/* harmony export */   "bb": function() { return /* binding */ FLOATING_ROUTE_MARKER_POINTER_TRANSFORMS; },
/* harmony export */   "c0": function() { return /* binding */ LABEL_SIZES; },
/* harmony export */   "dC": function() { return /* binding */ NEEDLE_SIZES; },
/* harmony export */   "eq": function() { return /* binding */ dragShadowMarginTop; },
/* harmony export */   "hT": function() { return /* binding */ LABEL_ENHANCER_POSITIONS; },
/* harmony export */   "o9": function() { return /* binding */ BADGE_ENHANCER_STYLES; },
/* harmony export */   "oE": function() { return /* binding */ dragShadowWidth; },
/* harmony export */   "ww": function() { return /* binding */ NEEDLE_HEIGHTS; },
/* harmony export */   "x5": function() { return /* binding */ PINHEAD_SIZES_SHAPES; },
/* harmony export */   "xC": function() { return /* binding */ PINHEAD_DIMENSIONS; }
/* harmony export */ });
/* unused harmony exports xSmallPinheadDimension, xxSmallPinheadDimension, FLOATING_MARKER_SIZES, FLOATING_MARKER_ANCHOR_TYPES, anchorSize, LOCATION_PUCK_SIZES, LOCATION_PUCK_TYPES, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS, FLOATING_ROUTE_MARKER_POINTER_TYPES, FLOATING_ROUTE_MARKER_POINTERS, FLOATING_ROUTE_MARKER_POINTER_TYPE_WRAPPER_SIZES */
var _Object$freeze, _Object$freeze2, _LABEL_SIZES, _xSmallPinheadBadge, _PINHEAD_SIZES_SHAPES, _PINHEAD_SIZES_SHAPES2, _PINHEAD_SIZES_SHAPES3, _BADGE_ENHANCER_POSIT, _BADGE_ENHANCER_STYLE, _BADGE_ENHANCER_CONTE, _Object$freeze3, _Object$freeze4, _Object$freeze5, _Object$freeze6;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var NEEDLE_SIZES = Object.freeze({
  none: 'none',
  short: 'short',
  medium: 'medium',
  tall: 'tall'
});
var NEEDLE_HEIGHTS = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, NEEDLE_SIZES.none, 0), _defineProperty(_Object$freeze, NEEDLE_SIZES.short, 4), _defineProperty(_Object$freeze, NEEDLE_SIZES.medium, 12), _defineProperty(_Object$freeze, NEEDLE_SIZES.tall, 20), _Object$freeze)); // Important: keep this sorted by size, as it used to determine label size when a secondary label is used.

var PINHEAD_SIZES_SHAPES = Object.freeze({
  xxSmallCircle: 'xx-small-circle',
  xxSmallSquare: 'xx-small-square',
  xSmallCircle: 'x-small-circle',
  xSmallSquare: 'x-small-square',
  small: 'small',
  medium: 'medium',
  large: 'large'
});
var xSmallPinheadDimension = {
  height: 16,
  icon: 4
};
var xxSmallPinheadDimension = {
  height: 8,
  icon: 4
};
var PINHEAD_DIMENSIONS = Object.freeze((_Object$freeze2 = {}, _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.xxSmallSquare, xxSmallPinheadDimension), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.xxSmallCircle, xxSmallPinheadDimension), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.xSmallSquare, xSmallPinheadDimension), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.xSmallCircle, xSmallPinheadDimension), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.small, {
  height: 24,
  icon: 16
}), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.medium, {
  height: 36,
  icon: 16
}), _defineProperty(_Object$freeze2, PINHEAD_SIZES_SHAPES.large, {
  height: 48,
  icon: 24
}), _Object$freeze2));
var PINHEAD_TYPES = Object.freeze({
  floating: 'floating',
  fixed: 'fixed'
});
var FLOATING_MARKER_SIZES = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});
var FLOATING_MARKER_ANCHOR_POSITIONS = Object.freeze({
  none: 'none',
  topLeft: 'top-left',
  topRight: 'top-right',
  bottomRight: 'bottom-right',
  bottomLeft: 'bottom-left'
});
var FLOATING_MARKER_ANCHOR_TYPES = Object.freeze({
  circle: 'circle',
  square: 'square',
  xxSmallCircle: 'xx-small-circle',
  xxSmallSquare: 'xx-small-square'
});
var dragShadowHeight = 4;
var dragShadowMarginTop = 6;
var dragShadowWidth = 6;
var anchorSize = 16;
var labelSmall = 'LabelSmall';
var LABEL_SIZES = (_LABEL_SIZES = {}, _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.xxSmallCircle, labelSmall), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.xxSmallSquare, labelSmall), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.xSmallCircle, labelSmall), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.xSmallSquare, labelSmall), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.small, labelSmall), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.medium, 'LabelMedium'), _defineProperty(_LABEL_SIZES, PINHEAD_SIZES_SHAPES.large, 'LabelLarge'), _LABEL_SIZES);
var LABEL_ENHANCER_POSITIONS = Object.freeze({
  none: 'none',
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom'
});
var BADGE_ENHANCER_SIZES = Object.freeze({
  none: 'none',
  xSmall: 'x-small',
  small: 'small',
  mediumText: 'medium-text',
  mediumIcon: 'medium-icon'
});
var xSmallPinheadBadge = (_xSmallPinheadBadge = {}, _defineProperty(_xSmallPinheadBadge, BADGE_ENHANCER_SIZES.none, null), _defineProperty(_xSmallPinheadBadge, BADGE_ENHANCER_SIZES.xSmall, {
  x: -5,
  y: -3
}), _defineProperty(_xSmallPinheadBadge, BADGE_ENHANCER_SIZES.small, null), _defineProperty(_xSmallPinheadBadge, BADGE_ENHANCER_SIZES.mediumText, null), _defineProperty(_xSmallPinheadBadge, BADGE_ENHANCER_SIZES.mediumIcon, null), _xSmallPinheadBadge);
var BADGE_ENHANCER_POSITIONS = (_BADGE_ENHANCER_POSIT = {}, _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.xxSmallSquare, null), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.xxSmallCircle, null), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.xSmallSquare, xSmallPinheadBadge), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.xSmallCircle, xSmallPinheadBadge), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.small, (_PINHEAD_SIZES_SHAPES = {}, _defineProperty(_PINHEAD_SIZES_SHAPES, BADGE_ENHANCER_SIZES.none, null), _defineProperty(_PINHEAD_SIZES_SHAPES, BADGE_ENHANCER_SIZES.xSmall, {
  x: -7,
  y: -1
}), _defineProperty(_PINHEAD_SIZES_SHAPES, BADGE_ENHANCER_SIZES.small, {
  x: -8,
  y: -8
}), _defineProperty(_PINHEAD_SIZES_SHAPES, BADGE_ENHANCER_SIZES.mediumText, null), _defineProperty(_PINHEAD_SIZES_SHAPES, BADGE_ENHANCER_SIZES.mediumIcon, null), _PINHEAD_SIZES_SHAPES)), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.medium, (_PINHEAD_SIZES_SHAPES2 = {}, _defineProperty(_PINHEAD_SIZES_SHAPES2, BADGE_ENHANCER_SIZES.none, null), _defineProperty(_PINHEAD_SIZES_SHAPES2, BADGE_ENHANCER_SIZES.xSmall, {
  x: -9,
  y: 1
}), _defineProperty(_PINHEAD_SIZES_SHAPES2, BADGE_ENHANCER_SIZES.small, {
  x: -10,
  y: -4
}), _defineProperty(_PINHEAD_SIZES_SHAPES2, BADGE_ENHANCER_SIZES.mediumText, {
  x: -12,
  y: -8
}), _defineProperty(_PINHEAD_SIZES_SHAPES2, BADGE_ENHANCER_SIZES.mediumIcon, {
  x: -12,
  y: -8
}), _PINHEAD_SIZES_SHAPES2)), _defineProperty(_BADGE_ENHANCER_POSIT, PINHEAD_SIZES_SHAPES.large, (_PINHEAD_SIZES_SHAPES3 = {}, _defineProperty(_PINHEAD_SIZES_SHAPES3, BADGE_ENHANCER_SIZES.none, null), _defineProperty(_PINHEAD_SIZES_SHAPES3, BADGE_ENHANCER_SIZES.xSmall, {
  x: -11,
  y: 3
}), _defineProperty(_PINHEAD_SIZES_SHAPES3, BADGE_ENHANCER_SIZES.small, null), _defineProperty(_PINHEAD_SIZES_SHAPES3, BADGE_ENHANCER_SIZES.mediumText, {
  x: -14,
  y: -6
}), _defineProperty(_PINHEAD_SIZES_SHAPES3, BADGE_ENHANCER_SIZES.mediumIcon, {
  x: -14,
  y: -6
}), _PINHEAD_SIZES_SHAPES3)), _BADGE_ENHANCER_POSIT);
var BADGE_ENHANCER_STYLES = (_BADGE_ENHANCER_STYLE = {}, _defineProperty(_BADGE_ENHANCER_STYLE, BADGE_ENHANCER_SIZES.none, {}), _defineProperty(_BADGE_ENHANCER_STYLE, BADGE_ENHANCER_SIZES.xSmall, {
  height: '8px',
  width: '8px',
  borderRadius: '50%'
}), _defineProperty(_BADGE_ENHANCER_STYLE, BADGE_ENHANCER_SIZES.small, {
  height: '16px',
  width: '16px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '10px'
}), _defineProperty(_BADGE_ENHANCER_STYLE, BADGE_ENHANCER_SIZES.mediumText, {
  borderRadius: '10px',
  height: '20px',
  padding: '0px 8px',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box'
}), _defineProperty(_BADGE_ENHANCER_STYLE, BADGE_ENHANCER_SIZES.mediumIcon, {
  height: '20px',
  width: '20px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box'
}), _BADGE_ENHANCER_STYLE);
var BADGE_ENHANCER_CONTENT_SIZE = (_BADGE_ENHANCER_CONTE = {}, _defineProperty(_BADGE_ENHANCER_CONTE, BADGE_ENHANCER_SIZES.none, 0), _defineProperty(_BADGE_ENHANCER_CONTE, BADGE_ENHANCER_SIZES.xSmall, 0), _defineProperty(_BADGE_ENHANCER_CONTE, BADGE_ENHANCER_SIZES.small, 10), _defineProperty(_BADGE_ENHANCER_CONTE, BADGE_ENHANCER_SIZES.mediumText, 12), _defineProperty(_BADGE_ENHANCER_CONTE, BADGE_ENHANCER_SIZES.mediumIcon, 12), _BADGE_ENHANCER_CONTE);
var KIND = Object.freeze({
  default: 'default',
  accent: 'accent',
  negative: 'negative'
});
var LOCATION_PUCK_SIZES = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});
var LOCATION_PUCK_TYPES = Object.freeze({
  consumer: 'consumer',
  earner: 'earner'
});
var EARNER_LOCATION_PUCK_CORE_SCALES = Object.freeze((_Object$freeze3 = {}, _defineProperty(_Object$freeze3, LOCATION_PUCK_SIZES.small, '50%'), _defineProperty(_Object$freeze3, LOCATION_PUCK_SIZES.medium, '75%'), _defineProperty(_Object$freeze3, LOCATION_PUCK_SIZES.large, '100%'), _Object$freeze3));
var FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS = Object.freeze({
  topLeft: 'top-left',
  topCenter: 'top-center',
  topRight: 'top-right',
  rightCenter: 'right-center',
  bottomRight: 'bottom-right',
  bottomCenter: 'bottom-center',
  bottomLeft: 'bottom-left',
  leftCenter: 'left-center'
});
var FLOATING_ROUTE_MARKER_POINTER_TYPES = Object.freeze({
  diagonal: 'diagonal',
  horizontal: 'horizontal',
  vertical: 'vertical'
});
var FLOATING_ROUTE_MARKER_POINTERS = Object.freeze((_Object$freeze4 = {}, _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topLeft, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.diagonal,
  path: 'M0 0L24 8L8 24L0 0Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topRight, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.diagonal,
  path: 'M24 0L0 8L16 24L24 0Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topCenter, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.vertical,
  path: 'M8.49928 0L0.499411 8L16.5006 8L8.49928 0Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomLeft, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.diagonal,
  path: 'M0 24L24 16L8 0L0 24Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomRight, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.diagonal,
  path: 'M24 24L0 16L16 0L24 24Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomCenter, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.vertical,
  path: 'M8.00133 8L16.0012 0H0L8.00133 8Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.leftCenter, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.horizontal,
  path: 'M0.000610352 8.00059L8.00061 16.0005L8.00061 -0.000732422L0.000610352 8.00059Z'
}), _defineProperty(_Object$freeze4, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.rightCenter, {
  type: FLOATING_ROUTE_MARKER_POINTER_TYPES.horizontal,
  path: 'M8.00061 7.99916L0.000610352 -0.000711441L0.000610352 16.0005L8.00061 7.99916Z'
}), _Object$freeze4));
var FLOATING_ROUTE_MARKER_POINTER_TRANSFORMS = Object.freeze((_Object$freeze5 = {}, _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topLeft, {
  transform: "translate(-33.33%, -33.33%)"
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topRight, {
  right: 0,
  transform: "translate(33.33%, -33.33%)"
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomLeft, {
  transform: "translate(-33.33%, 33.33%)",
  bottom: 0
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomRight, {
  right: 0,
  transform: "translate(33.33%, 33.33%)",
  bottom: 0
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.topCenter, {
  right: '50%',
  transform: "translate(50%, -100%)"
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.bottomCenter, {
  bottom: 0,
  right: '50%',
  transform: "translate(50%, 100%)"
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.leftCenter, {
  top: '50%',
  transform: "translate(-100%, -50%)"
}), _defineProperty(_Object$freeze5, FLOATING_ROUTE_MARKER_ANCHOR_POSITIONS.rightCenter, {
  left: '100%',
  top: '50%',
  transform: "translate(0%, -50%)"
}), _Object$freeze5));
var FLOATING_ROUTE_MARKER_POINTER_TYPE_WRAPPER_SIZES = Object.freeze((_Object$freeze6 = {}, _defineProperty(_Object$freeze6, FLOATING_ROUTE_MARKER_POINTER_TYPES.diagonal, {
  height: '24',
  width: '24',
  viewBox: '0 0 24 24'
}), _defineProperty(_Object$freeze6, FLOATING_ROUTE_MARKER_POINTER_TYPES.vertical, {
  height: '8',
  width: '17',
  viewBox: '0 0 17 8'
}), _defineProperty(_Object$freeze6, FLOATING_ROUTE_MARKER_POINTER_TYPES.horizontal, {
  height: '16',
  width: '8',
  viewBox: '0 0 8 16'
}), _Object$freeze6));

/***/ }),

/***/ 22832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ fixed_marker; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/baseui/esm/helpers/overrides.js + 1 modules
var helpers_overrides = __webpack_require__(52204);
// EXTERNAL MODULE: ./node_modules/baseui/esm/map-marker/constants.js
var constants = __webpack_require__(69369);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/styled-components.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var getAnchorTransform = function getAnchorTransform(anchor, anchorSize) {
  var _FLOATING_MARKER_ANCH;

  return (_FLOATING_MARKER_ANCH = {}, _defineProperty(_FLOATING_MARKER_ANCH, constants/* FLOATING_MARKER_ANCHOR_POSITIONS.none */.E.none, ""), _defineProperty(_FLOATING_MARKER_ANCH, constants/* FLOATING_MARKER_ANCHOR_POSITIONS.topLeft */.E.topLeft, "translate(".concat(anchorSize, "px, ").concat(anchorSize, "px)")), _defineProperty(_FLOATING_MARKER_ANCH, constants/* FLOATING_MARKER_ANCHOR_POSITIONS.topRight */.E.topRight, "translate(-100%, ".concat(anchorSize, "px)")), _defineProperty(_FLOATING_MARKER_ANCH, constants/* FLOATING_MARKER_ANCHOR_POSITIONS.bottomLeft */.E.bottomLeft, "translate(".concat(anchorSize, "px, -100%)")), _defineProperty(_FLOATING_MARKER_ANCH, constants/* FLOATING_MARKER_ANCHOR_POSITIONS.bottomRight */.E.bottomRight, "translate(-100%, -100%)"), _FLOATING_MARKER_ANCH)[anchor];
};
var StyledDragShadowContainer = (0,styled/* styled */.zo)('div', function (_ref) {
  var $theme = _ref.$theme,
      $height = _ref.$height,
      $width = _ref.$width,
      $dragging = _ref.$dragging;
  return {
    width: "".concat($width, "px"),
    height: "".concat($height, "px"),
    opacity: $dragging ? 1 : 0,
    visibility: $dragging ? 'visible' : 'hidden',
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all"),
    position: 'relative',
    boxShadow: $theme.lighting.shadow600
  };
});
StyledDragShadowContainer.displayName = "StyledDragShadowContainer";
StyledDragShadowContainer.displayName = 'StyledDragShadowContainer';
var StyledDragShadow = (0,styled/* styled */.zo)('div', function (_ref2) {
  var $theme = _ref2.$theme,
      $background = _ref2.$background,
      $width = _ref2.$width;
  return {
    backgroundColor: $background,
    borderRadius: '50%',
    width: "".concat($width, "px"),
    height: '4px',
    position: 'absolute',
    bottom: 0
  };
});
StyledDragShadow.displayName = "StyledDragShadow";
StyledDragShadow.displayName = 'StyledDragShadow';
var StyledNeedle = (0,styled/* styled */.zo)('div', function (_ref3) {
  var $theme = _ref3.$theme,
      $background = _ref3.$background,
      $height = _ref3.$height;
  return {
    backgroundColor: $background,
    width: '4px',
    height: "".concat($height, "px"),
    boxShadow: $theme.lighting.shadow600
  };
});
StyledNeedle.displayName = "StyledNeedle";
StyledNeedle.displayName = 'StyledNeedle';
var StyledFloatingMarkerRoot = (0,styled/* styled */.zo)('div', function (_ref4) {
  var $size = _ref4.$size;
  return {
    position: 'relative',
    height: "".concat($size, "px"),
    width: "".concat($size, "px")
  };
});
StyledFloatingMarkerRoot.displayName = "StyledFloatingMarkerRoot";
StyledFloatingMarkerRoot.displayName = 'StyledFloatingMarkerRoot';
var StyledFloatingMarkerPinHeadContainer = (0,styled/* styled */.zo)('div', function (_ref5) {
  var $theme = _ref5.$theme,
      $anchor = _ref5.$anchor,
      $anchorSize = _ref5.$anchorSize;
  return {
    position: 'absolute',
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all"),
    transform: getAnchorTransform($anchor, $anchorSize)
  };
});
StyledFloatingMarkerPinHeadContainer.displayName = "StyledFloatingMarkerPinHeadContainer";
StyledFloatingMarkerPinHeadContainer.displayName = 'StyledFloatingMarkerPinHeadContainer';
var StyledFloatingMarkerAnchorContainer = (0,styled/* styled */.zo)('div', function () {
  return {
    position: 'absolute'
  };
});
StyledFloatingMarkerAnchorContainer.displayName = "StyledFloatingMarkerAnchorContainer";
StyledFloatingMarkerAnchorContainer.displayName = 'StyledFloatingMarkerAnchorContainer';
var StyledFixedMarkerRoot = (0,styled/* styled */.zo)('div', function () {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  };
});
StyledFixedMarkerRoot.displayName = "StyledFixedMarkerRoot";
StyledFixedMarkerRoot.displayName = 'StyledFixedMarkerRoot';
var StyledFixedMarkerDragContainer = (0,styled/* styled */.zo)('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $translateAmount = _ref6.$translateAmount,
      $performTranslate = _ref6.$performTranslate;
  return {
    transform: "translateY(".concat($performTranslate ? "".concat($translateAmount, "px") : '0px', ")"),
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all"),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  };
});
StyledFixedMarkerDragContainer.displayName = "StyledFixedMarkerDragContainer";
StyledFixedMarkerDragContainer.displayName = 'StyledFixedMarkerDragContainer';
var StyledOuterXXSmallAnchor = (0,styled/* styled */.zo)('div', function (_ref7) {
  var $theme = _ref7.$theme,
      $round = _ref7.$round,
      $background = _ref7.$background,
      $size = _ref7.$size;
  return {
    backgroundColor: $background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: "".concat($size, "px"),
    width: "".concat($size, "px"),
    borderRadius: $round ? '50%' : 0,
    boxShadow: $theme.lighting.shadow600
  };
});
StyledOuterXXSmallAnchor.displayName = "StyledOuterXXSmallAnchor";
StyledOuterXXSmallAnchor.displayName = 'StyledOuterXXSmallAnchor';
var StyledInnerXXSmallAnchor = (0,styled/* styled */.zo)('div', function (_ref8) {
  var $round = _ref8.$round,
      $color = _ref8.$color,
      $size = _ref8.$size;
  return {
    backgroundColor: $color,
    height: "".concat($size, "px"),
    width: "".concat($size, "px"),
    borderRadius: $round ? '50%' : 0
  };
});
StyledInnerXXSmallAnchor.displayName = "StyledInnerXXSmallAnchor";
StyledInnerXXSmallAnchor.displayName = 'StyledInnerXXSmallAnchor';
var StyledOuterXSmallAnchor = (0,styled/* styled */.zo)('div', function (_ref9) {
  var $theme = _ref9.$theme,
      $round = _ref9.$round,
      $background = _ref9.$background,
      $size = _ref9.$size;
  return {
    backgroundColor: $background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: "".concat($size, "px"),
    width: "".concat($size, "px"),
    borderRadius: $round ? '50%' : 0,
    boxShadow: $theme.lighting.shadow600
  };
});
StyledOuterXSmallAnchor.displayName = "StyledOuterXSmallAnchor";
StyledOuterXSmallAnchor.displayName = 'StyledOuterXSmallAnchor';
var StyledInnerXSmallAnchor = (0,styled/* styled */.zo)('div', function (_ref10) {
  var $round = _ref10.$round,
      $color = _ref10.$color,
      $size = _ref10.$size;
  return {
    backgroundColor: $color,
    height: "".concat($size, "px"),
    width: "".concat($size, "px"),
    borderRadius: $round ? '50%' : 0
  };
});
StyledInnerXSmallAnchor.displayName = "StyledInnerXSmallAnchor";
StyledInnerXSmallAnchor.displayName = 'StyledInnerXSmallAnchor';
var StyledPinHead = (0,styled/* styled */.zo)('div', function (_ref11) {
  var $theme = _ref11.$theme,
      $height = _ref11.$height,
      $background = _ref11.$background,
      $gridTemplateColumns = _ref11.$gridTemplateColumns,
      $type = _ref11.$type,
      $forceCircle = _ref11.$forceCircle;
  var sharedStyles = {
    fixed: {
      padding: '0px 12px',
      borderRadius: "".concat($height, "px")
    },
    floating: {
      padding: '0px 8px'
    }
  };
  return _objectSpread(_objectSpread({
    backgroundColor: $background,
    height: "".concat($height, "px"),
    display: 'grid',
    gridTemplateColumns: $gridTemplateColumns,
    gap: '8px',
    boxShadow: $theme.lighting.shadow600,
    whiteSpace: 'nowrap'
  }, sharedStyles[$type]), $forceCircle && {
    width: "".concat($height, "px"),
    display: 'flex',
    justifyContent: 'center',
    boxSizing: 'border-box'
  });
});
StyledPinHead.displayName = "StyledPinHead";
StyledPinHead.displayName = 'StyledPinHead';
var StyledStrokedLabelContainer = (0,styled/* styled */.zo)('div', function (_ref12) {
  var $position = _ref12.$position,
      $theme = _ref12.$theme,
      $labelOffset = _ref12.$labelOffset;
  var staticLabelOffset = 4;
  var positions = {
    top: {
      left: "calc(50% + ".concat(staticLabelOffset, "px)"),
      bottom: '100%',
      alignItems: 'flex-end',
      justifyContent: 'center',
      textAlign: 'center'
    },
    bottom: {
      left: '50%',
      top: "calc(100% + ".concat(staticLabelOffset, "px + ").concat($labelOffset, "px)"),
      alignItems: 'flex-start',
      justifyContent: 'center',
      textAlign: 'center'
    },
    right: {
      left: "calc(100% + ".concat(staticLabelOffset, "px)"),
      top: '50%',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    left: {
      right: "calc(100% + ".concat(staticLabelOffset, "px)"),
      top: '50%',
      alignItems: 'center',
      justifyContent: 'flex-end',
      textAlign: 'right'
    },
    none: {}
  };
  return _objectSpread({
    position: 'absolute',
    width: '0px',
    height: '0px',
    pointerEvents: 'none',
    display: 'flex'
  }, positions[$position]);
});
StyledStrokedLabelContainer.displayName = "StyledStrokedLabelContainer";
StyledStrokedLabelContainer.displayName = 'StyledStrokedLabelContainer';
var StyledStrokedLabel = (0,styled/* styled */.zo)('div', function (_ref13) {
  var $theme = _ref13.$theme,
      $size = _ref13.$size;
  var strokeWidth = 1.5;
  var strokeColor = $theme.colors.backgroundPrimary;
  var textShadow = "-".concat(strokeWidth, "px -").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n    0 -").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n    ").concat(strokeWidth, "px -").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n    ").concat(strokeWidth, "px 0 0 ").concat(strokeColor, ",\n    ").concat(strokeWidth, "px ").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n    0 ").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n   -").concat(strokeWidth, "px ").concat(strokeWidth, "px 0 ").concat(strokeColor, ",\n   -").concat(strokeWidth, "px 0 0 ").concat(strokeColor);
  return _objectSpread(_objectSpread({
    display: 'flex'
  }, $theme.typography[constants/* LABEL_SIZES */.c0[$size]]), {}, {
    color: $theme.colors.primaryA,
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all"),
    textShadow: textShadow,
    pointerEvents: 'auto',
    width: 'max-content',
    maxWidth: '200px'
  });
});
StyledStrokedLabel.displayName = "StyledStrokedLabel";
StyledStrokedLabel.displayName = 'StyledStrokedLabel';
var StyledBadgeEnhancerRoot = (0,styled/* styled */.zo)('div', function (_ref14) {
  var $theme = _ref14.$theme,
      $size = _ref14.$size,
      $position = _ref14.$position;
  var x = $position.x,
      y = $position.y;
  return _objectSpread(_objectSpread({
    position: 'absolute'
  }, $theme.typography.LabelSmall), {}, {
    backgroundColor: $theme.colors.backgroundAccent,
    color: $theme.colors.primaryB,
    boxSizing: 'border-box',
    right: 0,
    transform: "translate(calc(100% + ".concat(x, "px), ").concat(y, "px)"),
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all")
  }, constants/* BADGE_ENHANCER_STYLES */.o9[$size]);
});
StyledBadgeEnhancerRoot.displayName = "StyledBadgeEnhancerRoot";
StyledBadgeEnhancerRoot.displayName = 'StyledBadgeEnhancerRoot';
var RelativeContainer = (0,styled/* styled */.zo)('div', function () {
  return {
    position: 'relative'
  };
});
RelativeContainer.displayName = "RelativeContainer";
RelativeContainer.displayName = 'RelativeContainer';
var StyledEnhancerSlot = (0,styled/* styled */.zo)('div', function (_ref15) {
  var $theme = _ref15.$theme,
      $color = _ref15.$color,
      $height = _ref15.$height,
      $size = _ref15.$size;
  return _objectSpread(_objectSpread({}, $theme.typography[constants/* LABEL_SIZES */.c0[$size]]), {}, {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    lineHeight: "".concat($height, "px"),
    height: "".concat($height, "px"),
    color: $color
  });
});
StyledEnhancerSlot.displayName = "StyledEnhancerSlot";
var StyledFloatingRouteMarkerRoot = (0,styled/* styled */.zo)('div', function (_ref16) {
  var $theme = _ref16.$theme,
      $height = _ref16.$height,
      $background = _ref16.$background,
      $gridTemplateColumns = _ref16.$gridTemplateColumns;
  return {
    position: 'absolute',
    backgroundColor: $background,
    height: "".concat($height, "px"),
    display: 'grid',
    gridTemplateColumns: $gridTemplateColumns,
    gap: '8px',
    filter: "drop-shadow(".concat($theme.lighting.shadow600, ")"),
    whiteSpace: 'nowrap',
    borderRadius: "".concat(8, "px"),
    padding: "".concat(4, "px ", 8, "px"),
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all")
  };
});
StyledFloatingRouteMarkerRoot.displayName = "StyledFloatingRouteMarkerRoot";
StyledFloatingRouteMarkerRoot.displayName = 'StyledFloatingRouteMarkerRoot';
StyledEnhancerSlot.displayName = 'StyledEnhancerSlot';
var StyledLabelSlot = (0,styled/* styled */.zo)('div', function () {
  return {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  };
});
StyledLabelSlot.displayName = "StyledLabelSlot";
StyledLabelSlot.displayName = 'StyledLabelSlot';
var StyledLabel = (0,styled/* styled */.zo)('div', function (_ref17) {
  var $theme = _ref17.$theme,
      $size = _ref17.$size,
      $renderSecondaryLabel = _ref17.$renderSecondaryLabel,
      $color = _ref17.$color;
  var pinheadSizeOrder = Object.values(constants/* PINHEAD_SIZES_SHAPES */.x5);
  var labelSizeIndex = pinheadSizeOrder.findIndex(function (x) {
    return $size === x;
  });

  if ($renderSecondaryLabel) {
    labelSizeIndex--;
  }

  var typographyStyle = constants/* LABEL_SIZES */.c0[pinheadSizeOrder[labelSizeIndex]];
  return _objectSpread(_objectSpread({}, $theme.typography[typographyStyle]), {}, {
    color: $color
  });
});
StyledLabel.displayName = "StyledLabel";
StyledLabel.displayName = 'StyledLabel';
var LocationPuckContainer = (0,styled/* styled */.zo)('div', function () {
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
});
LocationPuckContainer.displayName = "LocationPuckContainer";
LocationPuckContainer.displayName = 'LocationPuckContainer';
var consumerLocationShadow = {
  boxShadow: "0px 2px 4px 0px rgba(67, 76, 123, 0.2)"
};
var earnerLocationShadow = {
  boxShadow: "0px 3px 5px 0px rgba(67, 76, 123, 0.4)"
};
var StyledConsumerLocationPuckCore = (0,styled/* styled */.zo)('div', function (_ref18) {
  var $theme = _ref18.$theme;
  return _objectSpread({
    height: "".concat(12, "px"),
    width: "".concat(12, "px"),
    background: $theme.colors.contentAccent,
    borderRadius: "".concat(100, "px "),
    position: 'absolute'
  }, consumerLocationShadow);
});
StyledConsumerLocationPuckCore.displayName = "StyledConsumerLocationPuckCore";
var StyledLocationPuckApproximation = (0,styled/* styled */.zo)('div', function (_ref19) {
  var $theme = _ref19.$theme,
      $color = _ref19.$color,
      $radius = _ref19.$radius;
  return {
    background: $color,
    opacity: 0.12,
    height: "".concat($radius / 2, "px"),
    width: "".concat($radius / 2, "px"),
    borderRadius: "".concat(10000, "px "),
    position: 'absolute',
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all")
  };
});
StyledLocationPuckApproximation.displayName = "StyledLocationPuckApproximation";
StyledLocationPuckApproximation.displayName = 'StyledLocationPuckApproximation';
var StyledEarnerLocationPuckCore = (0,styled/* styled */.zo)('div', function (_ref20) {
  var $theme = _ref20.$theme,
      $color = _ref20.$color,
      $size = _ref20.$size;
  return _objectSpread(_objectSpread({
    position: 'absolute',
    transform: "scale(".concat(constants/* EARNER_LOCATION_PUCK_CORE_SCALES */.Kp[$size], ")"),
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all")
  }, earnerLocationShadow), {}, {
    borderRadius: '50%',
    height: "".concat(72, "px"),
    width: "".concat(72, "px"),
    background: $theme.colors.backgroundPrimary,
    border: "".concat(6, "px solid ", $color),
    boxSizing: 'border-box'
  });
});
StyledEarnerLocationPuckCore.displayName = "StyledEarnerLocationPuckCore";
StyledEarnerLocationPuckCore.displayName = 'StyledEarnerLocationPuckCore';
var StyledFloatingRouteMarkerPointerContainer = (0,styled/* styled */.zo)('svg', function (_ref21) {
  var $position = _ref21.$position;
  return _objectSpread({
    position: 'absolute'
  }, constants/* FLOATING_ROUTE_MARKER_POINTER_TRANSFORMS */.bb[$position]);
});
StyledFloatingRouteMarkerPointerContainer.displayName = "StyledFloatingRouteMarkerPointerContainer";
StyledFloatingRouteMarkerPointerContainer.displayName = 'StyledFloatingRouteMarkerPointerContainer';
var StyledFloatingRouteMarkerPointer = (0,styled/* styled */.zo)('path', function (_ref22) {
  var $theme = _ref22.$theme,
      $background = _ref22.$background;
  return {
    transition: "".concat($theme.animation.timing300, " ").concat($theme.animation.easeOutCurve, " all"),
    fill: $background
  };
});
StyledFloatingRouteMarkerPointer.displayName = "StyledFloatingRouteMarkerPointer";
StyledFloatingRouteMarkerPointer.displayName = 'StyledFloatingRouteMarkerPointer';
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/badge-enhancer.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var BadgeEnhancer = function BadgeEnhancer(_ref) {
  var pinHeadSize = _ref.pinHeadSize,
      markerType = _ref.markerType,
      _ref$badgeEnhancerSiz = _ref.badgeEnhancerSize,
      badgeEnhancerSize = _ref$badgeEnhancerSiz === void 0 ? constants/* BADGE_ENHANCER_SIZES.none */.A5.none : _ref$badgeEnhancerSiz,
      BadgeEnhancerContent = _ref.badgeEnhancerContent,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  if (badgeEnhancerSize === null || badgeEnhancerSize == constants/* BADGE_ENHANCER_SIZES.none */.A5.none) {
    return null;
  }

  if (badgeEnhancerSize !== constants/* BADGE_ENHANCER_SIZES.xSmall */.A5.xSmall && !BadgeEnhancerContent) {
    if (false) {}

    return null;
  }

  if (markerType === constants/* PINHEAD_TYPES.floating */.P6.floating) {
    if (false) {}

    return null;
  }

  var positions = constants/* BADGE_ENHANCER_POSITIONS */.UZ[pinHeadSize];
  var position = positions ? positions[badgeEnhancerSize] : null;

  if (!position) {
    if (false) {}

    return null;
  }

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.BadgeEnhancer, StyledBadgeEnhancerRoot),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      BadgeEnhancerRoot = _getOverrides2[0],
      badgeEnhancerRootProps = _getOverrides2[1];

  return /*#__PURE__*/react.createElement(BadgeEnhancerRoot, _extends({
    $size: badgeEnhancerSize,
    $position: position
  }, badgeEnhancerRootProps), BadgeEnhancerContent && badgeEnhancerSize !== constants/* BADGE_ENHANCER_SIZES.xSmall */.A5.xSmall && /*#__PURE__*/react.createElement(BadgeEnhancerContent, {
    size: constants/* BADGE_ENHANCER_CONTENT_SIZE */.T5[badgeEnhancerSize]
  }));
};

/* harmony default export */ var badge_enhancer = (BadgeEnhancer);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/label-enhancer.js
function label_enhancer_extends() { label_enhancer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return label_enhancer_extends.apply(this, arguments); }

function label_enhancer_slicedToArray(arr, i) { return label_enhancer_arrayWithHoles(arr) || label_enhancer_iterableToArrayLimit(arr, i) || label_enhancer_unsupportedIterableToArray(arr, i) || label_enhancer_nonIterableRest(); }

function label_enhancer_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function label_enhancer_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return label_enhancer_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return label_enhancer_arrayLikeToArray(o, minLen); }

function label_enhancer_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function label_enhancer_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function label_enhancer_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var LabelEnhancer = function LabelEnhancer(_ref) {
  var labelEnhancerContent = _ref.labelEnhancerContent,
      labelEnhancerPosition = _ref.labelEnhancerPosition,
      needleHeight = _ref.needleHeight,
      size = _ref.size,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  if (!labelEnhancerPosition || labelEnhancerPosition === constants/* LABEL_ENHANCER_POSITIONS.none */.hT.none) {
    return null;
  }

  if (!labelEnhancerContent) {
    return null;
  }

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.LabelEnhancerContainer, StyledStrokedLabelContainer),
      _getOverrides2 = label_enhancer_slicedToArray(_getOverrides, 2),
      StrokedLabelContainer = _getOverrides2[0],
      strokedLabelContainerProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.LabelEnhancer, StyledStrokedLabel),
      _getOverrides4 = label_enhancer_slicedToArray(_getOverrides3, 2),
      StrokedLabel = _getOverrides4[0],
      strokedLabelProps = _getOverrides4[1];

  return /*#__PURE__*/react.createElement(StrokedLabelContainer, label_enhancer_extends({
    $position: labelEnhancerPosition,
    $labelOffset: needleHeight
  }, strokedLabelContainerProps), /*#__PURE__*/react.createElement(RelativeContainer, null, /*#__PURE__*/react.createElement(StrokedLabel, label_enhancer_extends({
    $size: size
  }, strokedLabelProps), labelEnhancerContent)));
};

/* harmony default export */ var label_enhancer = (LabelEnhancer);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/pin-head.js
function pin_head_extends() { pin_head_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pin_head_extends.apply(this, arguments); }

function pin_head_slicedToArray(arr, i) { return pin_head_arrayWithHoles(arr) || pin_head_iterableToArrayLimit(arr, i) || pin_head_unsupportedIterableToArray(arr, i) || pin_head_nonIterableRest(); }

function pin_head_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function pin_head_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return pin_head_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pin_head_arrayLikeToArray(o, minLen); }

function pin_head_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function pin_head_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function pin_head_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/







var PinHead = function PinHead(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? constants/* PINHEAD_SIZES_SHAPES.medium */.x5.medium : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$secondaryLabel = _ref.secondaryLabel,
      secondaryLabel = _ref$secondaryLabel === void 0 ? '' : _ref$secondaryLabel,
      StartEnhancer = _ref.startEnhancer,
      EndEnhancer = _ref.endEnhancer,
      color = _ref.color,
      background = _ref.background,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? constants/* PINHEAD_TYPES.fixed */.P6.fixed : _ref$type,
      anchorType = _ref.anchorType,
      _ref$needle = _ref.needle,
      needle = _ref$needle === void 0 ? constants/* NEEDLE_SIZES.none */.dC.none : _ref$needle,
      labelEnhancerContent = _ref.labelEnhancerContent,
      labelEnhancerPosition = _ref.labelEnhancerPosition,
      badgeEnhancerSize = _ref.badgeEnhancerSize,
      badgeEnhancerContent = _ref.badgeEnhancerContent,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;
  var activeElements = [label, StartEnhancer, EndEnhancer].filter(function (x) {
    return x;
  });
  var gridTemplateColumns = activeElements.map(function () {
    return 'auto';
  }).join(' ');
  var forceCircle = activeElements.length === 1 && !label;
  var _PINHEAD_DIMENSIONS$s = constants/* PINHEAD_DIMENSIONS */.xC[size],
      height = _PINHEAD_DIMENSIONS$s.height,
      icon = _PINHEAD_DIMENSIONS$s.icon;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.PinHead, StyledPinHead),
      _getOverrides2 = pin_head_slicedToArray(_getOverrides, 2),
      PinHead = _getOverrides2[0],
      pinHeadProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.EnhancerSlot, StyledEnhancerSlot),
      _getOverrides4 = pin_head_slicedToArray(_getOverrides3, 2),
      EnhancerSlot = _getOverrides4[0],
      enhancerSlotProps = _getOverrides4[1];

  var _getOverrides5 = (0,helpers_overrides/* getOverrides */.jb)(overrides.LabelSlot, StyledLabelSlot),
      _getOverrides6 = pin_head_slicedToArray(_getOverrides5, 2),
      LabelSlot = _getOverrides6[0],
      labelSlotProps = _getOverrides6[1];

  var _getOverrides7 = (0,helpers_overrides/* getOverrides */.jb)(overrides.Label, StyledLabel),
      _getOverrides8 = pin_head_slicedToArray(_getOverrides7, 2),
      Label = _getOverrides8[0],
      labelProps = _getOverrides8[1];

  var _getOverrides9 = (0,helpers_overrides/* getOverrides */.jb)(overrides.SecondaryLabel, StyledLabel),
      _getOverrides10 = pin_head_slicedToArray(_getOverrides9, 2),
      SecondaryLabel = _getOverrides10[0],
      secondaryLabelProps = _getOverrides10[1];

  var _getOverrides11 = (0,helpers_overrides/* getOverrides */.jb)(overrides.InnerAnchor, StyledInnerXXSmallAnchor),
      _getOverrides12 = pin_head_slicedToArray(_getOverrides11, 2),
      InnerXXSmallAnchor = _getOverrides12[0],
      innerXXSmallAnchorProps = _getOverrides12[1];

  var _getOverrides13 = (0,helpers_overrides/* getOverrides */.jb)(overrides.OuterAnchor, StyledOuterXXSmallAnchor),
      _getOverrides14 = pin_head_slicedToArray(_getOverrides13, 2),
      OuterXXSmallAnchor = _getOverrides14[0],
      outerXXSmallAnchorProps = _getOverrides14[1];

  var _getOverrides15 = (0,helpers_overrides/* getOverrides */.jb)(overrides.InnerAnchor, StyledInnerXSmallAnchor),
      _getOverrides16 = pin_head_slicedToArray(_getOverrides15, 2),
      InnerXSmallAnchor = _getOverrides16[0],
      innerXSmallAnchorProps = _getOverrides16[1];

  var _getOverrides17 = (0,helpers_overrides/* getOverrides */.jb)(overrides.OuterAnchor, StyledOuterXSmallAnchor),
      _getOverrides18 = pin_head_slicedToArray(_getOverrides17, 2),
      OuterXSmallAnchor = _getOverrides18[0],
      outerXSmallAnchorProps = _getOverrides18[1];

  var badge = /*#__PURE__*/react.createElement(badge_enhancer, {
    markerType: type,
    pinHeadSize: size,
    badgeEnhancerSize: badgeEnhancerSize,
    badgeEnhancerContent: badgeEnhancerContent,
    overrides: overrides
  });

  if (type === constants/* PINHEAD_TYPES.fixed */.P6.fixed && (size === constants/* PINHEAD_SIZES_SHAPES.xxSmallCircle */.x5.xxSmallCircle || size === constants/* PINHEAD_SIZES_SHAPES.xxSmallSquare */.x5.xxSmallSquare)) {
    var round = size === constants/* PINHEAD_SIZES_SHAPES.xxSmallCircle */.x5.xxSmallCircle;
    return /*#__PURE__*/react.createElement(OuterXXSmallAnchor, pin_head_extends({
      $round: round,
      $background: background,
      $size: height
    }, outerXXSmallAnchorProps), /*#__PURE__*/react.createElement(InnerXXSmallAnchor, pin_head_extends({
      $color: color,
      $round: round,
      $size: icon
    }, innerXXSmallAnchorProps)));
  }

  if (type === constants/* PINHEAD_TYPES.fixed */.P6.fixed && (size === constants/* PINHEAD_SIZES_SHAPES.xSmallSquare */.x5.xSmallSquare || size === constants/* PINHEAD_SIZES_SHAPES.xSmallCircle */.x5.xSmallCircle)) {
    var _round = size === constants/* PINHEAD_SIZES_SHAPES.xSmallCircle */.x5.xSmallCircle;

    return /*#__PURE__*/react.createElement(RelativeContainer, null, badge, /*#__PURE__*/react.createElement(OuterXSmallAnchor, pin_head_extends({
      $round: _round,
      $background: background,
      $size: height
    }, outerXSmallAnchorProps), /*#__PURE__*/react.createElement(InnerXSmallAnchor, pin_head_extends({
      $color: color,
      $round: _round,
      $size: icon
    }, innerXSmallAnchorProps))));
  }

  var renderSecondaryLabel = (size === constants/* PINHEAD_SIZES_SHAPES.large */.x5.large || size === constants/* PINHEAD_SIZES_SHAPES.medium */.x5.medium) && secondaryLabel;
  return /*#__PURE__*/react.createElement(RelativeContainer, null, /*#__PURE__*/react.createElement(label_enhancer, {
    labelEnhancerContent: labelEnhancerContent,
    labelEnhancerPosition: labelEnhancerPosition,
    needleHeight: constants/* NEEDLE_HEIGHTS */.ww[needle],
    size: size,
    overrides: overrides
  }), badge, /*#__PURE__*/react.createElement(PinHead, pin_head_extends({
    $background: background,
    $height: height,
    $gridTemplateColumns: gridTemplateColumns,
    $forceCircle: forceCircle,
    $type: type
  }, pinHeadProps), StartEnhancer && /*#__PURE__*/react.createElement(EnhancerSlot, pin_head_extends({
    $height: height,
    $color: color,
    $size: size
  }, enhancerSlotProps), /*#__PURE__*/react.createElement(StartEnhancer, {
    size: icon
  })), label && /*#__PURE__*/react.createElement(LabelSlot, labelSlotProps, /*#__PURE__*/react.createElement(Label, pin_head_extends({
    $size: size,
    $renderSecondaryLabel: renderSecondaryLabel,
    $color: color
  }, labelProps), label), renderSecondaryLabel && /*#__PURE__*/react.createElement(SecondaryLabel, pin_head_extends({
    $size: size,
    $renderSecondaryLabel: renderSecondaryLabel,
    $color: color
  }, secondaryLabelProps), secondaryLabel)), EndEnhancer && /*#__PURE__*/react.createElement(EnhancerSlot, pin_head_extends({
    $height: height,
    $color: color,
    $size: size
  }, enhancerSlotProps), /*#__PURE__*/react.createElement(EndEnhancer, {
    size: icon
  }))));
};

/* harmony default export */ var pin_head = (PinHead);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/needle.js
function needle_extends() { needle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return needle_extends.apply(this, arguments); }

function needle_slicedToArray(arr, i) { return needle_arrayWithHoles(arr) || needle_iterableToArrayLimit(arr, i) || needle_unsupportedIterableToArray(arr, i) || needle_nonIterableRest(); }

function needle_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function needle_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return needle_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return needle_arrayLikeToArray(o, minLen); }

function needle_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function needle_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function needle_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var Needle = function Needle(_ref) {
  var size = _ref.size,
      background = _ref.background,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.Needle, StyledNeedle),
      _getOverrides2 = needle_slicedToArray(_getOverrides, 2),
      Needle = _getOverrides2[0],
      needleProps = _getOverrides2[1];

  return /*#__PURE__*/react.createElement(Needle, needle_extends({
    $background: background,
    $height: constants/* NEEDLE_HEIGHTS */.ww[size]
  }, needleProps));
};

/* harmony default export */ var map_marker_needle = (Needle);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/drag-shadow.js
function drag_shadow_extends() { drag_shadow_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return drag_shadow_extends.apply(this, arguments); }

function drag_shadow_slicedToArray(arr, i) { return drag_shadow_arrayWithHoles(arr) || drag_shadow_iterableToArrayLimit(arr, i) || drag_shadow_unsupportedIterableToArray(arr, i) || drag_shadow_nonIterableRest(); }

function drag_shadow_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function drag_shadow_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return drag_shadow_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return drag_shadow_arrayLikeToArray(o, minLen); }

function drag_shadow_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function drag_shadow_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function drag_shadow_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var DragShadow = function DragShadow(_ref) {
  var background = _ref.background,
      dragging = _ref.dragging,
      height = _ref.height,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.DragShadowContainer, StyledDragShadowContainer),
      _getOverrides2 = drag_shadow_slicedToArray(_getOverrides, 2),
      DragShadowContainer = _getOverrides2[0],
      dragShadowContainerProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.DragShadow, StyledDragShadow),
      _getOverrides4 = drag_shadow_slicedToArray(_getOverrides3, 2),
      DragShadow = _getOverrides4[0],
      dragShadowProps = _getOverrides4[1];

  return /*#__PURE__*/react.createElement(DragShadowContainer, drag_shadow_extends({
    $width: constants/* dragShadowWidth */.oE,
    $height: height,
    $dragging: dragging
  }, dragShadowContainerProps), /*#__PURE__*/react.createElement(DragShadow, drag_shadow_extends({
    $width: constants/* dragShadowWidth */.oE,
    $background: background
  }, dragShadowProps)));
};

/* harmony default export */ var drag_shadow = (DragShadow);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/map-marker/fixed-marker.js
var _excluded = ["size", "needle", "label", "startEnhancer", "endEnhancer", "kind", "dragging", "overrides", "labelEnhancerContent", "labelEnhancerPosition", "badgeEnhancerSize", "badgeEnhancerContent"];

function fixed_marker_extends() { fixed_marker_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fixed_marker_extends.apply(this, arguments); }

function fixed_marker_slicedToArray(arr, i) { return fixed_marker_arrayWithHoles(arr) || fixed_marker_iterableToArrayLimit(arr, i) || fixed_marker_unsupportedIterableToArray(arr, i) || fixed_marker_nonIterableRest(); }

function fixed_marker_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function fixed_marker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return fixed_marker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fixed_marker_arrayLikeToArray(o, minLen); }

function fixed_marker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function fixed_marker_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function fixed_marker_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/









function getColors(kind, theme) {
  if (kind === constants/* KIND.accent */.TO.accent) {
    return {
      color: theme.colors.contentInversePrimary,
      backgroundColor: theme.colors.backgroundAccent
    };
  }

  if (kind === constants/* KIND.negative */.TO.negative) {
    return {
      color: theme.colors.contentInversePrimary,
      backgroundColor: theme.colors.backgroundNegative
    };
  }

  return {
    color: theme.colors.contentInversePrimary,
    backgroundColor: theme.colors.backgroundInversePrimary
  };
}

var FixedMarker = function FixedMarker(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? constants/* PINHEAD_SIZES_SHAPES.medium */.x5.medium : _ref$size,
      _ref$needle = _ref.needle,
      needle = _ref$needle === void 0 ? constants/* NEEDLE_SIZES.medium */.dC.medium : _ref$needle,
      label = _ref.label,
      startEnhancer = _ref.startEnhancer,
      endEnhancer = _ref.endEnhancer,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? constants/* KIND.default */.TO["default"] : _ref$kind,
      _ref$dragging = _ref.dragging,
      dragging = _ref$dragging === void 0 ? false : _ref$dragging,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$labelEnhancerCon = _ref.labelEnhancerContent,
      labelEnhancerContent = _ref$labelEnhancerCon === void 0 ? null : _ref$labelEnhancerCon,
      _ref$labelEnhancerPos = _ref.labelEnhancerPosition,
      labelEnhancerPosition = _ref$labelEnhancerPos === void 0 ? constants/* LABEL_ENHANCER_POSITIONS.bottom */.hT.bottom : _ref$labelEnhancerPos,
      _ref$badgeEnhancerSiz = _ref.badgeEnhancerSize,
      badgeEnhancerSize = _ref$badgeEnhancerSiz === void 0 ? null : _ref$badgeEnhancerSiz,
      _ref$badgeEnhancerCon = _ref.badgeEnhancerContent,
      badgeEnhancerContent = _ref$badgeEnhancerCon === void 0 ? null : _ref$badgeEnhancerCon,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useStyletron = (0,styled/* useStyletron */.hQ)(),
      _useStyletron2 = fixed_marker_slicedToArray(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _getColors = getColors(kind, theme),
      color = _getColors.color,
      backgroundColor = _getColors.backgroundColor;

  var doesPinHeadTransformOnDrag = needle !== constants/* NEEDLE_SIZES.none */.dC.none && size !== constants/* PINHEAD_SIZES_SHAPES.xxSmallCircle */.x5.xxSmallCircle && size !== constants/* PINHEAD_SIZES_SHAPES.xxSmallSquare */.x5.xxSmallSquare;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(overrides.Root, StyledFixedMarkerRoot),
      _getOverrides2 = fixed_marker_slicedToArray(_getOverrides, 2),
      Root = _getOverrides2[0],
      rootProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(overrides.DragContainer, StyledFixedMarkerDragContainer),
      _getOverrides4 = fixed_marker_slicedToArray(_getOverrides3, 2),
      FixedMarkerDragContainer = _getOverrides4[0],
      fixedMarkerDragContainerProps = _getOverrides4[1];

  var renderNeedle = needle !== constants/* NEEDLE_SIZES.none */.dC.none && ![constants/* PINHEAD_SIZES_SHAPES.xxSmallCircle */.x5.xxSmallCircle, constants/* PINHEAD_SIZES_SHAPES.xxSmallSquare */.x5.xxSmallSquare].includes(size);

  if (false) {}

  var enhancers = {};

  if (startEnhancer) {
    enhancers.startEnhancer = startEnhancer;
  }

  if (endEnhancer) {
    enhancers.endEnhancer = endEnhancer;
  }

  return /*#__PURE__*/react.createElement(Root, fixed_marker_extends({
    "data-baseweb": "fixed-map-marker"
  }, rootProps), /*#__PURE__*/react.createElement(FixedMarkerDragContainer, fixed_marker_extends({
    $translateAmount: constants/* dragShadowMarginTop */.eq + constants/* dragShadowHeight */.AJ,
    $performTranslate: doesPinHeadTransformOnDrag && !dragging
  }, fixedMarkerDragContainerProps), /*#__PURE__*/react.createElement(pin_head, fixed_marker_extends({
    size: size,
    label: label
  }, enhancers, {
    color: color,
    background: backgroundColor,
    type: constants/* PINHEAD_TYPES.fixed */.P6.fixed,
    overrides: overrides,
    badgeEnhancerSize: badgeEnhancerSize,
    badgeEnhancerContent: badgeEnhancerContent,
    labelEnhancerContent: labelEnhancerContent,
    labelEnhancerPosition: labelEnhancerPosition,
    needle: needle
  })), renderNeedle && /*#__PURE__*/react.createElement(map_marker_needle, {
    size: needle,
    background: backgroundColor,
    overrides: overrides
  })), doesPinHeadTransformOnDrag && /*#__PURE__*/react.createElement(drag_shadow, {
    background: backgroundColor,
    dragging: dragging,
    height: constants/* dragShadowMarginTop */.eq + constants/* dragShadowHeight */.AJ,
    overrides: overrides
  }));
};

/* harmony default export */ var fixed_marker = (FixedMarker);

/***/ })

}]);